const localStorageMock = (() => {
  let store = {};
  return {
    getItem(key) {
      return store[key];
    },
    setItem(key, value) {
      store[key] = value.toString();
    },
    clear() {
      store = {};
    },
    removeItem(key) {
      delete store[key];
    }
  };
})();

export default window.localStorage || localStorageMock;



// WEBPACK FOOTER //
// ./src/redux/models/localStorage.js